export default "__VITE_ASSET__5ca785e6__"